import {
  IconBulb,
  IconRocket,
  IconUsers,
  IconTool,
  IconSchool,
  IconBriefcase
} from '@tabler/icons-react';

export const SOLUTION_TYPES = {
  INNOVATIVE: 'innovative',
  STARTUP: 'startup',
  COMMUNITY: 'community',
  TECHNICAL: 'technical',
  EDUCATIONAL: 'educational',
  BUSINESS: 'business'
};

export const SOLUTION_TYPE_STYLES = {
  [SOLUTION_TYPES.INNOVATIVE]: {
    label: 'Innovative',
    icon: <IconBulb size={20} />,
    bgColor: '#fef3c7',
    color: '#92400e',
    borderColor: '#fde68a'
  },
  [SOLUTION_TYPES.STARTUP]: {
    label: 'Startup',
    icon: <IconRocket size={20} />,
    bgColor: '#dbeafe',
    color: '#1e40af',
    borderColor: '#bfdbfe'
  },
  [SOLUTION_TYPES.COMMUNITY]: {
    label: 'Community',
    icon: <IconUsers size={20} />,
    bgColor: '#dcfce7',
    color: '#166534',
    borderColor: '#bbf7d0'
  },
  [SOLUTION_TYPES.TECHNICAL]: {
    label: 'Technical',
    icon: <IconTool size={20} />,
    bgColor: '#e0e7ff',
    color: '#3730a3',
    borderColor: '#c7d2fe'
  },
  [SOLUTION_TYPES.EDUCATIONAL]: {
    label: 'Educational',
    icon: <IconSchool size={20} />,
    bgColor: '#fce7f3',
    color: '#831843',
    borderColor: '#fbcfe8'
  },
  [SOLUTION_TYPES.BUSINESS]: {
    label: 'Business',
    icon: <IconBriefcase size={20} />,
    bgColor: '#f3e8ff',
    color: '#6b21a8',
    borderColor: '#e9d5ff'
  }
};
